import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material';



export const AirHeatExchangerIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Top square - fan from side view */}
      <rect
        x="6"
        y="4"
        width="12"
        height="4"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
      />
      
      {/* Fan blade indicators */}
      <g opacity="0.6">
        <line x1="7" y1="5" x2="17" y2="5" stroke="currentColor" strokeWidth="0.8" />
        <line x1="7" y1="6.5" x2="17" y2="6.5" stroke="currentColor" strokeWidth="0.8" />
        <line x1="7" y1="8" x2="17" y2="8" stroke="currentColor" strokeWidth="0.8" />
      </g>
      


      {/* Rectangular trapezoid below - rooftop condenser from side */}
      <polygon
        points="2,8 7,22 17,22 22,8"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      
      {/* Vertical structural lines */}
      <line
        x1="2"
        y1="8"
        x2="2"
        y2="23"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <line
        x1="22"
        y1="8"
        x2="22"
        y2="23"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      
      {/* Bottom structural line */}
      <line
        x1="2"
        y1="23"
        x2="22"
        y2="23"
        stroke="currentColor"
        strokeWidth="1.2"
      />
  
    </SvgIcon>
  );
};
